import _ from 'underscore'
import Vue from 'vue'
import Course from '../../resources/course'

// This is an object where courses will be stored
// with keys as the id, and course as the value
const state = {
  courses: [],
}

const getters = {
  allCourses(state) {
    return _.values(state.courses);
  },
};

const actions = {
  getCourses(context) {
    Course.query({}).then((res) => {
      context.commit(`RETRIEVE_COURSE_SUCCESS`, { courses: res.data})
    }, (res) => {
      Toast.error('Failed to retrieve courses')
    })
  },
  
  // payload.course
  deleteCourse(context, payload) {
    Course.delete({id: payload.course.id}).then((res) => {
      context.commit(`DELETE_COURSE_SUCCESS`, {course: payload.course});
    }, (res) => {
      Toast.error('Failed to delete course')
    })
  },

  // payload.id, payload.changes
  updateCourse(context, payload) {
    Course.update({ id: payload.id }, payload.changes).then((res) => {
      context.commit(`UPDATE_COURSE_SUCCESS`, { course: res.data });
      if (_.isFunction(payload.callback)) payload.callback();
    }, (res) => {
      Toast.error('Failed to save course')
    })
  },

   createCourse(context, payload) {
     Course.save(payload.course).then((res) => {
       context.commit('CREATE_COURSE_SUCCESS', {course: res.data});
     }, (res) => {
       Toast.error('Failed to create course')
     })
   },

}

const mutations = {

  RETRIEVE_COURSE_SUCCESS(state, payload) {
    _.each(payload.courses, (course) => {
      Vue.set(state.courses, course.id, course);
    })
  },

  DELETE_COURSE_SUCCESS(state, payload) {
    Vue.delete(state.courses, payload.course.id);
  },

  // payload.course
  UPDATE_COURSE_SUCCESS(state, payload) {
    Vue.set(state.courses, payload.course.id, payload.course);
  },

  CREATE_COURSE_SUCCESS(state, payload) {
    Vue.set(state.courses, payload.course.id, payload.course);
  },

}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/courses.js